import React from 'react'

import { Modal, Button, Divider } from '_zari/core'

import * as Tables from '../../tables'
import * as Sections from './sections'

const ControlLetrasModal = ({ show, handleClose, dispatch, letras, vFechaEmision, vMontoTotal, vTipoSocio, siguienteCorrelativo }) => {
  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>CONTROL LETRAS</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Sections.LetraCabeceraSection
          dispatch={dispatch}
          vFechaEmision={vFechaEmision}
          vTipoSocio={vTipoSocio}
          siguienteCorrelativo={siguienteCorrelativo}
        />
        <Divider />
        <Tables.LetrasAsignadasTable letras={letras} dispatch={dispatch} flagControl />
        <Divider />
        <Sections.InfoDiferenciasSection letras={letras} vMontoTotal={vMontoTotal} />
      </Modal.Body>
      <Modal.Footer>
        <Button outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ControlLetrasModal)
